import gsap from 'gsap';

export default class HeaderNotification {
	static init() {
		const notifications = document.querySelectorAll('.header-notification');
        if (!notifications.length) { // check after ie11 message is removed
            return;
        }

		Array.from(notifications).forEach(element => {
			new HeaderNotification(element);
		});

        HeaderNotification.updateHeaderNotificationHeight();
        window.addEventListener('resize', HeaderNotification.updateHeaderNotificationHeight);
	}

	constructor(element) {
		if (element.classList.contains('is-ie-11-only')) {
			const isIe11 = !!window.MSInputMethodContext && !!document.documentMode;
			if (isIe11) {
				element.classList.remove('is-hidden');
			} else {
				element.remove();
				return;
			}
		}

		const closeButton = element.querySelector('.info-close');
		closeButton.addEventListener('click', (event) => {
			event.stopPropagation();
			event.preventDefault();
			const headerheight = document.querySelector('.header-main').clientHeight;

			gsap.to(element, {
				height: 0,
				duration: 0.6,
				ease: 'power4.out',
				onComplete: () => {
					element.remove();
				}
			});

            if ($('.page-banner').length) {
                gsap.to('.page-banner', {
                    paddingTop: headerheight,
                    duration: 0.6,
                    ease: 'power4.out'
                });
            }

            HeaderNotification.updateHeaderNotificationHeight();
		});
	}

    static updateHeaderNotificationHeight() {
        const headerNotifications = Array.from(document.querySelectorAll('.header-notification'));
        const headerNotificationsHeight = headerNotifications.reduce((acc, notification) => {
            return acc + notification.clientHeight;
        }, 0);
        document.body.style.setProperty('--header-notification-height', headerNotificationsHeight + 'px');
    }
}
